
import tags from '../api/tags'

export const state = {
  tags: [],
  tag_pagination_data: {},
  tag: ''
}

export const getters = {
  tags: state => state.tags,
  tag_pagination_data: state => state.tag_pagination_data,
  tag: state => state.tag
}

export const mutations = {
  ADD_TAG (state, data) {
    state.tags.push(data)
  },
  SET_TAGS (state, data) {
    state.tags = data
  },
  SET_TAG_PAGINATION (state, data) {
    state.tag_pagination_data = data
  },
  SHOW_TAG (state, data) {
    state.tag = data
  }
}

export const actions = {
  GET_TAGS ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      tags.get(data).then(response => {
        commit('SET_TAGS', response.data.data)
        let paginationData = {
          from: response.data.from,
          to: response.data.to,
          total: response.data.total,
          last_page: response.data.last_page
        }
        commit('SET_TAG_PAGINATION', paginationData)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  GET_ALL_TAGS ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      tags.getall(data).then(response => {
        commit('SET_TAGS', response.data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  CREATE_TAG ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      tags.create(data).then(response => {
        commit('ADD_TAG', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  SHOW_TAG ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      tags.show(id).then(response => {
        commit('SHOW_TAG', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  EDIT_TAG ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      tags.update(data, state.tag.id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  REMOVE_TAG ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      tags.delete(id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/tags.js